/*
 * @Author: JamesWong
 * @Description: 小票配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: chutao.fang
 * @Last Modified time: 2021-03-18 20:06:04
 */
export default {
  styleDisposition: '样式配置',
  ticketPreview: '小票预览',
  createDeposit: '定金单',
  detail: '详情',
  edit: '编辑',
  save: '保存',
  cancel: '取消',
  printLabel: '打印标示',
  reprintLabel: '重打印标示（仅在重打印的小票上显示）',
  headPhotos: '头部图片',
  headPart: '头部',
  ticketInfo: '单据信息',
  ticketNo: '小票号',
  operateTime: '操作时间',
  cashier: '收银员',
  assistant: '营业员',
  assistantCode: '营业员编号',
  assistantName: '营业员名称',
  storeNo: '店铺编号',
  storeAddr: '店铺地址',
  storePhone: '店铺电话',
  storeMobile: '店铺手机',
  VIPNo: '会员编号',
  remarks: '销售备注',
  Goods: '货品',
  Quty: '数量',
  Amt: '金额',
  Total: '合计',
  PriceTotal: '总额',
  Benefit: '优惠',
  VIPPrice: '会员价',
  DCT: '折扣',
  DiscountedPrice: '折后价',
  ValueBalance: '储值余额',
  TagPrice: '吊牌价',
  goodsInfo: '货品信息',
  promotionInfo: '促销信息',
  allPromotionsTicket: '该单所有的促销',
  promotionDesc: '促销描述',
  promotionNotes: '促销备注',
  paymentMethod: '付款明细',
  defaultPayment: '默认样式：应付+所有应用到的支付方式',
  tailPhotos: '尾部图片',
  salesExplanation: '销售说明',
  tailpart: '尾部',
  quantitySet: '张数配置',
  salesCreateReciept: '销售做单',
  numberChannelVersion: '店铺联打印张数',
  complete: '完成',
  numberCustomerVersion: '顾客联打印张数',
  reprintSalesReciept: '重打印销售单',
  tips: '提示',
  updatedTips: '更新小票配置成功',
  precept: '方案',
  cashierAndName: '收银员：张三',
  assistantAndName: '营业员：1001-王晓',
  storeNoAndName: '店铺编号：1009-店铺',
  storeAddrAndName: '店铺地址：广州市番禺区天安节能科技园15号楼',
  payable: '应付',
  cash: '现金支付',
  integralBalance: '积分余额',
  printThirtpartOrder: '支付流水号',
  thridSeralNumber: '第三方支付的商户支付流水号',
  TicketNumberEdited: '小票数修改成功！',
  TicketNumberEditedError1: '请输入0-3之间的数字',
  TicketNumberEditedError2: '数量不能超过 3',
  photoUploadTips: '注：请先选择图片，可用鼠标滑动调整图片的大小、位置，已达到理想打印效果。如超过边框，图片会按照300:130进行裁切。',
  selectPhotos: '选择图片',
  leftTurn: '向左旋转',
  rightTurn: '向右旋转',
  upload: '上传',
  confirm: '确定',
  markSet: '标示设置',
  markSetMsg: '隐藏"店铺联/顾客联"标示',
  markSetCustomer: '顾客联',
  invoiceScanUrlText: '发票二维码',
  invoiceScanUrl: '显示发票二维码(ERP配置后生效)',
  invoiceDesc: '发票描述',
  '添加二维码': '添加二维码',
  '请输入二维码内容': '请输入二维码内容',
  '自定义二维码': '自定义二维码',
  '二维码描述': '二维码描述',
  '销售单号': '销售单号',
  '手工单号': '手工单号',
  '会员卡号': '会员卡号',
  '会员手机': '会员手机',
  etc: '等',
  Coupon: '代用券',
  Date: '日期',
  printCoupons: '打印代用券',
  promoteCounpon: '促销赠券',
  rechargeCounpon: '充值赠券',
  primeCostInfo: '原价总额',
  primeCostInfoDetail: '(货品总吊牌额)',
  DiscountTotal: '优惠总额',
  alreadyDiscountInfo: '已优惠',
  alreadyDiscountInfoDetail: '(已优惠=吊牌额-应付)',
  实付: '实付',
  生意额: '生意额',
  getIntegrateInfo: '获得积分',
  remainingIntegrateInfo: '积分余额',
  uploadPhoto: '上传图片',
  autoSavePhoto: '自动生成条码图片',
  autoSelectNum: '选择自动生成条形码的单号',
  Saleno: '销售单号',
  manualSaleNo: '手工单号',
  barCode: '条形码',
  qrCode: '二维码',
  qrCodeText: '二维码内容',
  takeCareMsg: '注意：手工单号相对较长，转成条形码可能过长，导致扫描不出来，建议使用二维码',
  cancelMsg: '取 消',
  saveMsg: '保 存',
  addParagraph: '+新增段落',
  addEmptyParagraph: '+新增空行',
  paragraphMsg: '段落',
  leftAlign: '左对齐',
  centerAlign: '居中',
  deleteMsg: '删除',
  blankLine: '空行',
  goodsSpace: '货品显示',
  goodsSpaceMsg: '货品之间空行隔开',
  showGoodsTotal: '货品合计',
  showGoodsTotalMsg: '显示合计',
  middlePic: '自定义图片',
  tailImageDesc: '图片描述',
  barCodeStyle: '条码样式',
  smallTicketNum: '小票号',
  goodsType10: '条形码',
  goodsType10Unique: '唯一码',
  goodsType17: '条形码/唯一码',
  goodsType2: '条形码/品名',
  goodsType2Unique: '唯一码/品名',
  goodsType22: '条形码/品类',
  goodsType22Unique: '唯一码/品类',
  goodsType4: '条形码/品名/吊牌价',
  goodsType4Unique: '唯一码/品名/吊牌价',
  goodsType44: '条形码/品类/吊牌价',
  goodsType44Unique: '唯一码/品类/吊牌价',
  goodsType5: '条形码/品名/会员价/折后价',
  goodsType5Unique: '唯一码/品名/会员价/折后价',
  goodsType55: '条形码/品类/会员价/折后价',
  goodsType55Unique: '唯一码/品类/会员价/折后价',
  goodsType7: '条形码/品名/会员价/折扣/折后价',
  goodsType7Unique: '唯一码/品名/会员价/折扣/折后价',
  goodsType77: '条形码/品类/会员价/折扣/折后价',
  goodsType77Unique: '唯一码/品类/会员价/折扣/折后价',
  goodsType1: '货号-品名/颜色/内长/尺码',
  goodsType6: '货号-品名/颜色/内长/尺码/会员价/折后价',
  goodsType8: '货号-品名/颜色/内长/尺码/会员价/折扣/折后价',
  goodsType3: '货号-品名/颜色/内长/尺码/吊牌价',
  goodsType9: '货号-品名/颜色/内长/尺码/吊牌价/折扣/折后价',
  goodsType11: '货号-品类/颜色/内长/尺码',
  goodsType66: '货号-品类/颜色/内长/尺码/会员价/折后价',
  goodsType88: '货号-品类/颜色/内长/尺码/会员价/折扣/折后价',
  goodsType33: '货号-品类/颜色/内长/尺码/吊牌价',
  goodsType99: '货号-品类/颜色/内长/尺码/吊牌价/折扣/折后价',
  goodsType100: '货号-品名/颜色/内长/尺码/零售价/零售折扣/折后价',
  goodsType101: '货号-品类/颜色/内长/尺码/零售价/零售折扣/折后价',
  categoryReplaceName: '使用品类替换品名',
  uniqueReplaceBarcode: '使用唯一码替换条形码',
  Amt_mang: '满',
  Available: '可用',
  '渠道配置中心': '渠道配置中心',
  '单据打印样式管理': '单据打印样式管理',
  '配置样式请至渠道配置中心操作': '配置样式请至"渠道配置中心"操作',
  '单据': '单据',
  '新增简易版样式': '新增简易版样式',
  '新增定义版样式': '新增自定义版样式',
  '自定义版': '自定义版',
  '简易版': '简易版',
  '简易版编辑器': '简易版编辑器',
  '自定义编辑器': '自定义编辑器',
  '空样式': '样式',
  '样式名称': '样式名称',
  '样式文档名称': '样式文档名称',
  '输入样式文档名称': '输入样式文档名称',
  '建议备注宽度以便区分': '建议备注宽度以便区分',
  '图片大小不超过': '图片大小不超过',
  '选择单据': '选择单据',
  '选择模版': '选择模版',
  '空白模版': '空白模版',
  '请检查样式是否缺漏': '请检查样式是否缺漏',
  '您正在进行模版编辑操作, 是否放弃编辑?': '您正在进行模版编辑操作, 是否放弃编辑?',
  '销售单': '销售单',
  '定金单': '定金单',
  '日结': '日结',
  '交接班': '交接班',
  '本机日收银': '本机日收银',
  '充值单': '充值单',
  '调拨收货': '调拨收货',
  '采购收货': '采购收货',
  '渠道收货': '渠道收货',
  '渠道调拨': '渠道调拨',
  '渠道退货': '渠道退货',
  '仓库出货': '仓库出货',
  '渠道采购到货通知': '渠道采购到货通知',
  '渠道调出通知': '渠道调出通知',
  '退货通知': '退货通知',
  '渠道采购退货通知': '渠道采购退货通知',
  '线上订单发货': '线上订单发货',
  '收货单': '收货单',
  '成品采购入库单(基础)': '成品采购入库单(基础)',
  '发货单': '发货单',
  '采购退货': '采购退货',
  '紧急发货(基础)': '紧急发货(基础)',
  '配货单(基础)': '配货单(基础)',
  '发货退货(基础)': '发货退货(基础)',
  '到货通知单(基础)': '到货通知单(基础)',
  '采购退货(基础)': '采购退货(基础)',
  '采购退货通知(基础)': '采购退货通知(基础)',
  '验货(基础)': '验货(基础)',
  '自定义文本': '自定义文本',
  '模版名称': '模版名称',
  '模板已保存': '模板已保存',
  '可通过渠道配置中心配置渠道使用': '可通过"渠道配置中心"配置渠道使用',
  '选择样式': '选择样式',
  '税额': '税额',
  '显示税额': '显示税额',
  '买满立减(按单)': '买满立减(按单)',
  '买满打折(按货品)': '买满打折(按货品)',
  '买满送优惠券': '买满送优惠券',
  '顾客签名栏': '顾客签名栏',
  '打印太阳码': '打印太阳码',
  '显示顾客签名栏': '显示顾客签名栏',
  '显示已用代用券券号': '显示已用代用券券号',
  '已用代用券': '已用代用券',
  '折扣取反(适用于非中国大陆地区)': '折扣取反(适用于非中国大陆地区)',
  '会员姓名': '会员姓名',
  '会员等级': '会员等级',
  '营业员(货品)': '营业员(货品)',
  '代用券': '代用券',
  'A4显示货品营业员': 'A4显示货品营业员',
  '营业员': '营业员',
  '渠道调入': '渠道调入',
  '发货': '发货',
  '配单': '配单',
  '退货': '退货',
  '定金单号': '定金单号',
  '核销单号': '核销单号',
  'printCounterChannelAbb': '专柜(商场打印)',
  'printCounterChannelAbbs': '专柜',
  '活动说明': '活动说明',
  '显示赠送代用券活动说明': '显示赠送代用券活动说明',
  '请选择要编辑的模版': '请选择要编辑的模版',
  '批量打印': '批量打印',
  '顺丰面单打印': '顺丰面单打印',
  '零售配单验货': '零售配单验货',
  '销补发货': '销补发货',
  '收货工作台': '收货工作台',
  '线上订单工作台': '线上订单工作台',
  维修单: '维修单',
  补货: '补货',
  '发快递（影儿）': '发快递（影儿）',
  '价签打印': '价签打印'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/slip.js